import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import Box from 'fe-design-base/atoms/Box';
import Icon from 'fe-design-base/atoms/Icon';
import Text from 'fe-design-base/atoms/Text/Text';
import Link from 'fe-design-base/molecules/Link';

import { getShowAutopayrollExceededCreditLimitBanner } from 'selectors/session';

import { toI18n } from 'util/i18n';
import { browserHistory } from 'util/router';

const I18N_PREFIX = 'payroll.banners.autopayroll_exceeded_credit_limit';

const PayrollAutopayrollExceededCreditLimitBanner = () => {
  const showAutopayrollExceededCreditLimitBanner = useSelector(
    getShowAutopayrollExceededCreditLimitBanner
  );

  const handleOnClick = useCallback(() => {
    browserHistory.push('/payroll');
  }, []);

  return showAutopayrollExceededCreditLimitBanner ? (
    <Box h={45} row tcenter vcenter hcenter bgcolor="red100">
      <Box row vcenter>
        <Icon
          mt={2}
          mr={8}
          size="medium"
          color="error300"
          iconName="Critical"
        />
        <Text variant="heading4" color="mono900">
          {toI18n(`${I18N_PREFIX}.title`)}
        </Text>
        &nbsp; &nbsp;
        <Text variant="body" color="mono900">
          {toI18n(`${I18N_PREFIX}.body`)}
        </Text>
        &nbsp; &nbsp;
        <Link size="medium" onClick={handleOnClick}>
          {toI18n(`${I18N_PREFIX}.link`)}
        </Link>
      </Box>
    </Box>
  ) : null;
};

export default PayrollAutopayrollExceededCreditLimitBanner;
